import { render } from "./InputBase.vue?vue&type=template&id=2b64fd36"
import script from "./InputBase.vue?vue&type=script&lang=js"
export * from "./InputBase.vue?vue&type=script&lang=js"

import exportComponent from "/srv/airschedule.jetphix.com/releases/33/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__